module.exports = __webpack_public_path__ + "img/25_61.5c963486.png";